import { defineMessages } from 'react-intl-next';

export default defineMessages({
	emptyStateHeader: {
		id: 'dev-agents.app.settings.code-planner.code-planner-configuration.empty-state-header',
		defaultMessage: 'No projects found',
		description:
			'The header of the message displayed in the empty state of the code planner settings page.',
	},
	emptyStateDescription: {
		id: 'dev-agents.app.settings.code-planner.code-planner-configuration.empty-state-description',
		defaultMessage:
			'Please check you have administrative privileges to Jira projects and try again.',
		description: 'The message displayed in the emtpy state of the code planner settings page.',
	},
	siteSettingsTitle: {
		id: 'dev-agents.app.settings.code-planner.site-settings.site-settings-title',
		defaultMessage: 'Site settings',
		description:
			'The title of the section where the site level settings are displayed on the code planner settings page.',
	},
	siteSettingsDescription: {
		id: 'dev-agents.app.settings.code-planner.site-settings.site-settings-description',
		defaultMessage: 'Enable or disable Code Planner for all Jira projects in {siteName}',
		description:
			'The description of the section where the site level settings are displayed on the code planner settings page.',
	},
	enableAllReposButtonTitle: {
		id: 'dev-agents.app.settings.code-planner.site-settings.enable-all-repos-button-title',
		defaultMessage: 'Enable for all repositories',
		description: 'The title of the button that allows users to enable code planner for all repos.',
	},
	disableAllReposButtonTitle: {
		id: 'dev-agents.app.settings.code-planner.site-settings.disable-all-repos-button-title',
		defaultMessage: 'Disable for all repositories',
		description: 'The title of the button that allows users to disable code planner for all repos.',
	},
	toggleAllReposButtonGroupTitle: {
		id: 'dev-agents.app.settings.code-planner.site-settings.toggle-all-repos-button-group-title',
		defaultMessage: 'Enable or disable Code Planner for all Jira projects',
		description:
			'The title of the button group that has buttons to enable or disable code planner for all repos.',
	},
	projectTitle: {
		id: 'dev-agents.app.settings.code-planner.jira-projects-table.project-title',
		defaultMessage: 'Jira projects',
		description:
			'The title of the row that displays jira projects in a table that displays code planner settings.',
	},
	searchPlaceholder: {
		id: 'dev-agents.app.settings.code-planner.jira-projects-table.search-placeholder',
		defaultMessage: 'Search project names',
		description:
			'The placeholder text in a search box that allows users to search projects by their names',
	},
	projectKey: {
		id: 'dev-agents.app.settings.code-planner.jira-projects-table.project-key',
		defaultMessage: 'Key',
		description:
			'The title of the row that displays jira project keys in the table that displays code planner settings.',
	},
	projectName: {
		id: 'dev-agents.app.settings.code-planner.jira-projects-table.project-name',
		defaultMessage: 'Name',
		description:
			'The title of the row that displays jira project names in the table that displays code planner settings.',
	},
	enabledStatus: {
		id: 'dev-agents.app.settings.code-planner.jira-projects-table.enabled-status',
		defaultMessage: 'Automatic coding plans',
		description:
			'The title of the row that displays whether coding agents is enabled or not in the table that displays code planner settings.',
	},
});
